import { render, staticRenderFns } from "./saltype.vue?vue&type=template&id=146bfb2f&scoped=true&"
import script from "./saltype.vue?vue&type=script&lang=js&"
export * from "./saltype.vue?vue&type=script&lang=js&"
import style0 from "./saltype.vue?vue&type=style&index=0&id=146bfb2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146bfb2f",
  null
  
)

export default component.exports